import { Check, Clock } from 'lucide-react';

interface ServiceCardService {
  id: string;
  name: string;
  price: number;
  description?: string;
  duration?: string;
}

interface ServiceCardProps {
  service: ServiceCardService;
  selected: boolean;
  onToggle: (id: string) => void;
  disabled?: boolean;
}

const ServiceCard = ({ service, selected, onToggle, disabled = false }: ServiceCardProps) => {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={() => onToggle(service.id)}
      disabled={disabled}
      className={`w-full rounded-xl border-2 p-4 text-left transition-all duration-150 ${
        selected
          ? 'border-primary bg-primary-light ring-primary/20 shadow-md ring-1'
          : disabled
            ? 'border-border bg-card cursor-not-allowed opacity-50'
            : 'border-border bg-card hover:border-primary/30 hover:shadow-sm'
      } disabled:pointer-events-none`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h4 className="text-card-foreground text-base leading-tight font-semibold wrap-anywhere">{service.name}</h4>
          {service.description && (
            <p className="text-muted-foreground mt-1 line-clamp-2 text-sm">{service.description}</p>
          )}
          <div className="mt-2.5 flex flex-wrap items-center gap-3">
            <span className="text-primary text-base font-bold">R$ {service.price.toFixed(2).replace('.', ',')}</span>
            {service.duration && (
              <span className="text-muted-foreground flex items-center gap-1 text-xs">
                <Clock className="h-3.5 w-3.5" />
                {service.duration}
              </span>
            )}
          </div>
        </div>
        <div
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-all ${
            selected ? 'border-primary bg-primary' : 'border-border'
          }`}
        >
          {selected && <Check className="text-primary-foreground h-3.5 w-3.5" />}
        </div>
      </div>
    </button>
  );
};

export default ServiceCard;
